export default __webpack_public_path__ + "static/media/Home-Filled.222fde78.svg";